import { Button } from '@talentmesh/ui/components/button';
import { cn } from '@talentmesh/ui/lib/utils';
import { Loader2 } from 'lucide-react';
import React, { type ReactNode } from 'react';

export type NextStepButtonProps = Omit<React.ComponentProps<typeof Button>, 'type' | 'size' | 'variant'> & {
    loading?: boolean;
    endIcon?: ReactNode;
};

const NextStepButton = ({ loading, endIcon, children, className, disabled, ...props }: NextStepButtonProps) => {
    return (
        <Button
            type="submit"
            size="default"
            variant="default"
            disabled={disabled || loading}
            className={cn('gap-2', className)}
            {...props}
        >
            {loading ? <Loader2 className="size-4 shrink-0 animate-spin" aria-hidden /> : null}
            {children}
            {endIcon ? <span className="inline-flex shrink-0">{endIcon}</span> : null}
        </Button>
    );
};

export default NextStepButton;
